import { cn } from 'corso-admin-ui';
import { match } from 'ts-pattern';
import FallbackImage from '~/components/FallbackImage';
import { MediaDownloadPrompt } from './MediaDownloadPrompt';
import { MediaFallback } from './MediaFallback';
import { useMediaContentType } from './useMediaContentType';

export function MediaFull({
  src,
  alt,
  className,
}: {
  src: string;
  alt: string;
  className?: string;
}) {
  const { data, isPending, isError } = useMediaContentType(src);

  if (isPending) {
    return <MediaFallback type="loading" alt={alt} className={className} />;
  }
  if (isError) {
    return <MediaFallback type="error" alt={alt} className={className} />;
  }

  return match(data.type)
    .with('image', () => (
      <FallbackImage
        loading="lazy"
        src={src}
        alt={alt}
        className={cn(
          'size-full rounded-md object-contain object-center',
          className,
        )}
      />
    ))
    .with('video', () => (
      // oxlint-disable-next-line jsx-a11y/media-has-caption -- no track/caption content available
      <video
        src={src}
        controls
        aria-label={alt}
        className={cn('size-full object-contain', className)}
      >
        Your browser does not support the video tag.
      </video>
    ))
    .with('pdf', () => (
      <>
        <iframe
          title="PDF Preview"
          loading="lazy"
          src={src}
          className={cn('hidden size-full border-none md:block', className)}
        />
        <div className={cn('size-full md:hidden', className)}>
          <MediaDownloadPrompt src={src} alt={alt} />
        </div>
      </>
    ))
    .with(null, () => <MediaDownloadPrompt src={src} alt={alt} />)
    .exhaustive();
}
